export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      conseil: "Conseil",
      audit: "Audit",
      formation: "Formation",
      mediation: "Médiation",
      about: "Le Cabinet",
      contact: "Contact"
    },
    common: {
      strategyLabel: "Stratégie",
      analysisLabel: "Analyse",
      moduleLabel: "Module",
      pillarLabel: "Axe",
      ctaTitle: "Contact",
      serviceLabel: "Expertise"
    },
    hero: {
      subtitle: "Performance Architect",
      title: "L'Ingénierie de la Performance Achats",
      description: "Vos achats représentent 60 à 80% du chiffre d'affaires de votre entreprise. Nous vous aidons à en reprendre le contrôle — et à transformer chaque euro dépensé en levier de performance.",
      cta: "Engager l'audit stratégique"
    },
    services: {
      conseil: {
        title: "Ingénierie Sourcing",
        lead: "Vos fournisseurs sont-ils vraiment les meilleurs ? Vos contrats vous protègent-ils réellement ? Payez-vous le juste prix ? Si vous ne pouvez pas répondre à ces trois questions avec certitude, il est temps d'en parler.",
        items: ["Optimisation du TCO", "Design-to-Cost", "Stratégies catégorielles", "Make or Buy"],
        descriptions: [
          "Le prix d'achat ne représente souvent que 40% du coût réel. Transport, stockage, non-qualité, coûts administratifs — ces lignes invisibles érodent vos marges en silence. Nous les identifions, les chiffrons et les éliminons.",
          "Le cahier des charges est souvent rédigé par ceux qui utiliseront le produit, rarement par ceux qui le paieront. Nous intervenons avant l'appel d'offres pour challenger les besoins et construire un cahier des charges efficient.",
          "Acheter du mobilier de bureau et négocier un contrat de maintenance industrielle, ce n'est pas le même métier. Nous construisons une stratégie d'achat adaptée à chaque famille de produits ou services.",
          "Faut-il internaliser ou externaliser ? La réponse dépend de dizaines de variables : coûts sociaux, risques de dépendance, capacité interne. Nous posons les chiffres sur la table pour une décision éclairée."
        ]
      },
      audit: {
        title: "Audit de Maturité",
        lead: "Un regard neutre et expert pour transformer vos dépenses en opportunités de croissance. Nous identifions les zones de risques et les gisements de profit cachés dans votre organisation.",
        items: ["Diagnostic 360°", "Audit de conformité", "Performance fournisseur", "Gisements de productivité"],
        descriptions: [
          "Notre diagnostic cartographie l'ensemble de votre dépense en 4 à 8 semaines et livre une photographie claire : où part l'argent, qui décide, et où sont les leviers immédiats.",
          "Un contrat signé il y a trois ans protège-t-il encore votre entreprise aujourd'hui ? Notre audit vérifie chaque engagement et identifie les risques juridiques et opérationnels.",
          "Un fournisseur stratégique qui livre en retard est un risque pour votre production. Nous mesurons la performance réelle de vos partenaires clés pour sécuriser vos flux.",
          "Chaque audit révèle des économies réalisables à court terme. Des contrats jamais mis en concurrence aux doublons de fournisseurs, nous identifions des gains directs pour votre EBITDA."
        ]
      },
      formation: {
        title: "Academy Experts",
        lead: "Le savoir-faire est le premier actif de l'entreprise. Nos programmes transforment vos collaborateurs en négociateurs d'élite et en gestionnaires de risques avertis.",
        items: ["Négociation haut niveau", "Analyse financière", "Leadership", "Risk Management"],
        descriptions: [
          "Maîtriser les leviers psychologiques et tactiques pour aboutir à des accords équilibrés. Une compétence essentielle pour protéger les marges de l'entreprise.",
          "Si votre acheteur ne sait pas lire un bilan, il négocie à l'aveugle. Nous apprenons à vos équipes à décoder les comptes d'un fournisseur pour en tirer des conclusions opérationnelles.",
          "Développer l'influence et la posture décisionnelle. Apprendre à porter des projets complexes au sein de l'organisation et à faire reconnaître la valeur stratégique des achats.",
          "Identifier et neutraliser les menaces avant qu'elles ne deviennent des crises. Nous enseignons une méthodologie concrète pour bâtir des plans B avant d'en avoir besoin."
        ]
      },
      mediation: {
        title: "Médiation Stratégique",
        lead: "Le conflit est un coût invisible. Nous intervenons comme tiers de confiance pour dénouer les situations complexes et transformer les litiges en accords constructifs.",
        items: ["Relations critiques", "Résolution de conflits", "Renégociation contrats", "Gestion de crise"],
        descriptions: [
          "Sécuriser les liens avec vos partenaires indispensables. Nous intervenons pour restaurer le dialogue et la confiance lorsque les enjeux financiers sont menacés.",
          "Sortir des impasses contractuelles par la négociation raisonnée. Notre approche privilégie des solutions rapides et pérennes, évitant les procédures juridiques coûteuses.",
          "Rééquilibrer vos engagements face aux évolutions du marché (matières premières, énergie). Nous pilotons les renégociations pour protéger vos intérêts sans rompre le partenariat.",
          "En cas de rupture brutale ou de défaillance majeure d'un fournisseur, nous pilotons la sortie de crise pour minimiser l'impact sur votre performance globale."
        ]
      }
    },
    about: {
      title: "Le Cabinet",
      philosophy: "L'excellence opérationnelle n'est pas une option, c'est le socle de notre engagement envers votre performance globale.",
      historyTitle: "Notre histoire",
      historyText: "MBK Procurement est né d'un constat simple : les entreprises dépensent des millions auprès de leurs fournisseurs, mais très peu investissent dans la manière dont elles achètent. Des contrats signés à la hâte, des fournisseurs jamais challengés — et au bout du compte, des marges qui s'érodent.",
      historyText2: "Après 15 ans passés à diriger des transformations achats pour des groupes européens, nous avons créé MBK avec une conviction : chaque entreprise mérite une fonction achats à la hauteur de ses ambitions.",
      adnTitle: "Identité Stratégique",
      adnDescription: "MBK est né de la conviction que les achats sont le moteur secret de la rentabilité. Nous fusionnons rigueur analytique et vision business pour transformer chaque ligne de dépense en avantage compétitif.",
      methodTitle: "Standards d'Excellence",
      methodDescription: "Nous appliquons des méthodologies issues des plus hauts standards du conseil international. Notre approche est pragmatique, mesurable et orientée vers un ROI immédiat pour nos clients.",
      commitmentResultTitle: "Résultats mesurables",
      commitmentResultText: "Nous délivrons un impact concret sur votre P&L. Si nous n'avons pas d'impact mesurable sur votre rentabilité, nous considérons notre mission comme inachevée.",
      commitmentTransferTitle: "Transfert de compétences",
      commitmentTransferText: "Notre objectif est de rendre vos équipes autonomes. Chaque mission inclut un volet formation et des outils transférés pour que votre organisation soit plus forte après notre départ.",
      commitmentConfidentialityTitle: "Confidentialité absolue",
      commitmentConfidentialityText: "Nous traitons vos données stratégiques avec une discrétion totale. Aucune information n'est réutilisée et aucun nom de client n'est cité sans accord explicite."
    }
  },
  en: {
    nav: {
      home: "Home",
      conseil: "Consulting",
      audit: "Audit",
      formation: "Academy",
      mediation: "Mediation",
      about: "The Firm",
      contact: "Contact"
    },
    common: {
      strategyLabel: "Strategy",
      analysisLabel: "Analysis",
      moduleLabel: "Module",
      pillarLabel: "Pillar",
      ctaTitle: "Contact",
      serviceLabel: "Expertise"
    },
    hero: {
      subtitle: "Performance Architect",
      title: "Procurement Performance Engineering",
      description: "Your procurement represents 60 to 80% of your company's revenue. We help you take back control — and turn every euro spent into a performance lever.",
      cta: "Initiate Strategic Audit"
    },
    services: {
      conseil: {
        title: "Sourcing Engineering",
        lead: "Are your suppliers really the best? Do your contracts actually protect you? Are you paying the right price? If you can't answer these questions, it's time to talk.",
        items: ["TCO Optimization", "Design-to-Cost", "Category Strategies", "Make or Buy"],
        descriptions: [
          "Purchase price often represents only 40% of the real cost. We identify and eliminate hidden costs in transport, storage, and administration.",
          "Specifications are often written by users, not buyers. We challenge needs before the tender to build efficient and cost-effective requirements.",
          "Buying office furniture and industrial maintenance require different skills. We build a purchasing strategy tailored to each category.",
          "Insource or outsource? We analyze social costs, dependency risks, and internal capacity to help you make an informed strategic decision."
        ]
      },
      audit: {
        title: "Maturity Audit",
        lead: "A neutral and expert eye to transform your expenses into growth opportunities. We identify risk zones and hidden profit sources.",
        items: ["360° Diagnosis", "Compliance Audit", "Supplier Performance", "Productivity Mapping"],
        descriptions: [
          "We scan your entire organization to understand where every euro goes, delivering a clear picture of immediate levers for savings.",
          "Does a contract signed three years ago still protect your business? Our audit checks every commitment and identifies legal risks.",
          "A strategic supplier that delivers late is a risk to production. We measure actual performance to secure your supply chain.",
          "Every audit reveals short-term achievable savings. From un-tendered contracts to supplier duplicates, we identify direct EBITDA gains."
        ]
      },
      formation: {
        title: "Academy Experts",
        lead: "Know-how is a company's primary asset. Our programs transform your employees into elite negotiators and savvy risk managers.",
        items: ["High-Level Negotiation", "Financial Analysis", "Leadership", "Risk Management"],
        descriptions: [
          "Mastering psychological and tactical levers to reach balanced agreements. An essential skill to protect company margins.",
          "If your buyer can't read a balance sheet, they're negotiating blind. We teach teams to decode supplier financials for operational conclusions.",
          "Developing influence and a decisive posture. Learning to lead complex projects and demonstrate the strategic value of procurement.",
          "Identifying and neutralizing threats before they become crises. We teach concrete methodologies to build backup plans ahead of time."
        ]
      },
      mediation: {
        title: "Strategic Mediation",
        lead: "Conflict is an invisible cost. We act as a trusted third party to untangle complex situations and transform disputes into agreements.",
        items: ["Critical Relationships", "Conflict Resolution", "Contract Renegotiation", "Crisis Management"],
        descriptions: [
          "Securing links with indispensable partners. We intervene to restore dialogue and trust when financial stakes are threatened.",
          "Breaking through contractual deadlocks through reasoned negotiation. Our approach favors quick solutions over costly legal procedures.",
          "Rebalancing commitments in the face of market changes (raw materials, energy). We manage renegotiations to protect your interests.",
          "In the event of a sudden supplier failure, we manage the crisis exit to minimize the impact on your overall performance."
        ]
      }
    },
    about: {
      title: "The Firm",
      philosophy: "Operational excellence is not an option; it is the foundation of our commitment to your overall performance.",
      historyTitle: "Our story",
      historyText: "MBK Procurement was born from a simple observation: companies spend millions with suppliers, but few invest in how they buy. Poorly structured tenders and un-challenged suppliers lead to eroding margins.",
      historyText2: "After 15 years leading procurement transformations for European groups, we created MBK with one conviction: every company deserves a top-tier procurement function.",
      adnTitle: "Strategic Identity",
      adnDescription: "Procurement is the secret engine of profitability. We merge analytical rigor and business vision to turn every expense into a competitive advantage.",
      methodTitle: "Standards of Excellence",
      methodDescription: "We apply methodologies from the highest standards of international consulting. Our approach is pragmatic and ROI-oriented.",
      commitmentResultTitle: "Measurable results",
      commitmentResultText: "We deliver a concrete impact on your P&L. If we don't have a measurable impact on your profitability, our mission is not finished.",
      commitmentTransferTitle: "Knowledge transfer",
      commitmentTransferText: "Our goal is to make your teams autonomous. Every mission includes training and tools so your organization is stronger after we leave.",
      commitmentConfidentialityTitle: "Absolute confidentiality",
      commitmentConfidentialityText: "We treat your strategic data with total discretion. No information is reused and no client name is cited without explicit consent."
    }
  }
};
